<template>
<div class="brokerageSale">
    <div class="total bgc">
        <div class="left">
            <div class="outbox">
                <div class="innerbox">
                    <div class="box">
                        <div class="name">
                            <span>商品佣金</span>
                        </div>
                        <div class="value tc-blue">￥{{summary.brokeragesale}}</div>
                    </div>
                    <div class="box">
                        <div class="name">
                            <span>团长佣金</span>
                        </div>
                        <div class="value tc-green">￥{{summary.brokerageheader}}</div>
                    </div>
                    <div class="box">
                        <div class="name">
                            <span>推荐佣金</span>
                        </div>
                        <div class="value tc-red">￥{{summary.brokeragerecommend}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="filters bgc">
                <div class="add">
                    <el-button type="danger" @click="handleQuery(1)" :class="[param.timetype!=1?'is-disabled': '']">
                        今天
                    </el-button>
                    <el-button type="primary" @click="handleQuery(2)"
                               :class="[param.timetype!=2?'is-disabled': '']">昨天
                    </el-button>
                    <el-button type="success" @click="handleQuery(3)"
                               :class="[param.timetype!=3?'is-disabled': '']">近7天
                    </el-button>
                    <el-button type="warning" @click="handleQuery(4)"
                               :class="[param.timetype!=4?'is-disabled': '']">近30天
                    </el-button>
                </div>
                <div class="search">
                    <el-date-picker class="dateInput" v-model="date" type="daterange" align="right" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                    format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <el-button type="primary" @click="handleQuery(0)">确认筛选</el-button>
                    <el-button type="success" @click="handleExport">下载表格</el-button>
                </div>
            </div>
            <div class="echert">
                <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import LineReport from 'base/echarts/lineReport'
import {mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
import {getDataStatisticsByBrokerage, exportDataStatisticsByBrokerage} from 'api/brandBusiness'
export default {
    name: 'brokerageSale',
    props: ['summary'],
    data() {
        return {
            param: {
                beginTime: '',
                datatype: '',
                endTime: '',
                headerinnerid: this.$route.query.headerinnerid ? this.$route.query.headerinnerid : '',
                timetype: 3 //  0自定义 1今日 2昨日 3近7日 4近30日
            },
            lineDatas: {
                id: 'brokerageSale',
                subText: '',
                xdata: [],
                data: [],
                legendAddr: 'left',
                formatter: '{a0}: {c0}<br />{a1}: {c1}<br />{a2}: {c2}'
            },
            date: [],
            init: false
        }
    },
    mounted() {
        this._getDataStatisticsByBrokerage()
    },
    methods: {
        handleQuery(index) {
            if (!index && !this.date.length) {
                this.$message.error('请选择筛选日期')
                return false
            } else if (!index && !!this.date.length) {
                this.param.beginTime = this.date[0]
                this.param.endTime = this.date[1]
            }
            this.param.timetype = index
            this._getDataStatisticsByBrokerage()
        },
        handleExport() {
            this.setLoading(true)
            exportDataStatisticsByBrokerage({
                data: this.param,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '佣金数据' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getDataStatisticsByBrokerage() {
            this.setLoading(true)
            getDataStatisticsByBrokerage({
                data: Object.assign({}, this.param),
                success: data => {
                    this.lineDatas.xdata = data.data.datelist
                    this.lineDatas.data=[]
                    this.lineDatas.data.push(
                        {
                            title: '商品佣金',
                            color: '#5AD8A6',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.brokerageproductlist
                        }
                    )
                    this.lineDatas.data.push(
                        {
                            title: '团长佣金',
                            color: '#5B8FF9',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.brokeragebyheaderlist
                        }
                    )
                    this.lineDatas.data.push(
                        {
                            title: '推荐佣金',
                            color: '#5D7092',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.brokeragerecommendlist
                        }
                    )
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        LineReport
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.brokerageSale {
    margin-top: 30px;
}
</style>
